export default __webpack_public_path__ + "static/media/CountingNumbers.bb7a960f4f9e4456b3078cdef8c48c2d.webp";